import React from 'react';

import CommonNode from '../../../components/node/common-node';
import { NodeProvider } from '../../../context/node-context';
import PaycomWriterForm from '../forms/paycom-writer-form';
import { paycomWriterValidationSchema } from '../schema/paycomWriter.js';

export default function PaycomWriterNode({ data, id, type }) {
  return (
    <NodeProvider
      nodeData={data}
      id={id}
      type={type}
      metaData={{
        modalTitle: data?.label || 'Paycom Writer Node Details',
        altText: 'Paycom Writer Node',
        defaultLabel: 'Paycom Writer Node',
      }}
    >
      <CommonNode FormComponent={PaycomWriterForm} schemaResolver={paycomWriterValidationSchema} />
    </NodeProvider>
  );
}
